import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Header } from './components/Header';
import { PaystackPayment } from './components/PaystackPayment';

function Payment() {
  return (
    <div className="App">
      <Header />
      <PaystackPayment />
    </div>
  );
}

export default Payment;